import { rj } from "react-rocketjump"
import { indicatorStaticsApi } from "../api"

export const IndicatorStaticsState = rj({
  effectCaller: rj.configured(),
  effect: token => () => indicatorStaticsApi(token)
})
